var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"GORALLocationControls p-1 px-3"},[_c('div',{staticClass:"filters"},[_c('MultiSelectFilter',{staticClass:"GORalProactiveFilter",attrs:{"filter-config":_vm.proactiveConfig}}),_c('MultiSelectFilter',{staticClass:"GORALStatusFilter",attrs:{"filter-config":_vm.statusConfig}})],1),_c('TableActiveFilters')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }